import { DroplistOptions } from 'app/interfaces/fields';
import { IAuditWithUserInterface } from '../../../../global/audit.interface';
import { DocumentTypeCustomBoxesData } from '../../contract-control/contract-control.dto';
import { PagingDto } from '../../users/userslisting/dto/paging.dto';
import { IField } from '../documenttype/document-type-settings-modal/document-type-settings.dto';

export interface IIMetadataItemOptionsDto extends DroplistOptions {
    name: string,
    value: string,
    meta_data_id: number,
    user_id: number,
    id: number
}

export enum MetaDataTypeEnum {
    text = 'text',
    checkbox = 'checkbox',
    droplist = 'droplist',
    datepicker = 'datepicker',
    image = 'image'
}

export enum ValidationTypeEnum{
    numbers='numbers',
    letter='letters',
    email='email',
    regex='reqex',
    numbers_letters='numbers_letters',
    custom_regex_validation='custom_regex_validation'
}

export enum PersonDataTypeEnum{
    FullName='Full name',
    LastName='Last name',
    Email='Email',
    PhoneNo ='Phone no',
    PersonalIDNumber='Personal ID number',
    Address='Address',
    ZipCode='Zip code',
    City='City',
}

export enum OrganizationDataTypeEnum{
    Organization='Organization',
    PhoneNo ='Phone no',
    RegNo='Reg no',
    Address='Address',
    ZipCode='Zip code',
    City='City',
}

export enum DocumentGeneralDataTypeEnum{
    signing_date='signing_date',
    template_name='template_name'
}

export interface ICustomFieldDto {
    id?: number,
    meta_data_id?: number, 
    value?: string, 
    expire_at?: string, 
    file_name?: string,
    field_type?: string
}

export interface IMetadataItemDto {
    api_attribute: string
    created_at: Date | string,
    document_type_custom_boxes_data?: Partial<IField>,
    field_validations?: FieldValidations,
    id: number,
    is_required: 0 | 1,
    meta_data_description?: string,
    hint?: string,
    meta_data_name: string
    placeholder?: string
    meta_data_option: IIMetadataItemOptionsDto[],
    meta_data_type: MetaDataTypeEnum,
    section: string,
    source?: string,
    multi_select?: number 
    multiple_line_field?: number 
    updated_at: Date | string,
    user_id: number,
    disabled?: boolean,
    workspace_id: number,
    api_field?: number 
    api_url?: string,
    api_key?: string,
    expire_days?: number
}

export interface ICreateMetadataResponse extends IAuditWithUserInterface {
    api_attribute:string;
    field_validations: FieldValidations;
    id:number;
    meta_data_description:string
    meta_data_name:string;
    meta_data_option: [];
    meta_data_type:MetaDataTypeEnum;
    section :string;
    workspace_id:number;
}

export interface FieldValidations {
    created_at?: Date | string,
    decimals?: number
    fieldable_id?: number,
    fieldable_type?: string,
    id?: number,
    max?: number,
    min?: number,
    number_validation_type?: string,
    recipient_role_extrafield_id?: number,
    regular_expression?: string,
    updated_at?: Date | string,
    user_id?: number,
    validation_help_text?: string
    validation_type?: ValidationTypeEnum
    workspace_id?: number
    type?: null
}

export interface IMetadataListDTO extends PagingDto {
    data: IMetadataItemDto[]
}
